import React, { FunctionComponent, Fragment, useEffect } from "react";
import { useThree } from "react-three-fiber";

interface ICameraControllerProps {
  rotatingObject: React.MutableRefObject<THREE.Group | undefined>;
  backgroundRef: React.MutableRefObject<any>;
}

export const CameraController: FunctionComponent<ICameraControllerProps> = (props) => {
  const { rotatingObject, backgroundRef } = props;

  const { gl } = useThree();

  // wyld
  useEffect(() => {
    if (backgroundRef.current) {
      const backgroundElement = backgroundRef.current;
      const canvasElement = gl.domElement;
      let isDragging = false;

      let previousTouch: Touch | null = null;
      const enableDragging = () => (isDragging = true);
      const disableDragging = () => {
        isDragging = false;
        previousTouch = null;
      };
      const rotate = (event: MouseEvent) => {
        if (isDragging && rotatingObject.current) {
          rotatingObject.current.rotation.y = rotatingObject.current.rotation.y + event.movementX * 0.01;
        }
      };

      const rotateTouch = (event: TouchEvent) => {
        const touch = event.touches[0];
        const movementX = previousTouch ? previousTouch.pageX - touch.pageX : 0;
        if (isDragging && rotatingObject.current) {
          rotatingObject.current.rotation.y = rotatingObject.current.rotation.y - movementX * 0.01;
        }
        previousTouch = touch;
      };

      canvasElement.addEventListener("mousedown", enableDragging);
      canvasElement.addEventListener("touchstart", enableDragging);
      backgroundElement.addEventListener("mouseup", disableDragging);
      backgroundElement.addEventListener("touchend", disableDragging);
      backgroundElement.addEventListener("mouseleave", disableDragging);
      backgroundElement.addEventListener("touchcancel", disableDragging);
      backgroundElement.addEventListener("mousemove", rotate);
      backgroundElement.addEventListener("touchmove", rotateTouch);

      return () => {
        canvasElement.removeEventListener("mousedown", enableDragging);
        canvasElement.removeEventListener("touchstart", enableDragging);
        backgroundElement.removeEventListener("mouseup", disableDragging);
        backgroundElement.removeEventListener("touchend", disableDragging);
        backgroundElement.removeEventListener("mouseleave", disableDragging);
        backgroundElement.removeEventListener("touchcancel", disableDragging);
        backgroundElement.removeEventListener("mousemove", rotate);
        backgroundElement.removeEventListener("touchemove", rotateTouch);
      };
    }
    return () => {};
  }, [backgroundRef, rotatingObject, gl.domElement]);
  return <Fragment />;
};
